import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from '../pages/AuthPages';
import Terms from '../pages/Terms';
import { DealerRegistrationPage } from '../pages/DealerRegistrationPage';
import { openDealerApp } from '../utils/app';
import { isEmbeddedPurchasesRoute } from '../utils/embed';

export const UnloggedRoutes = () => {
  const { user } = useSelector(state => state.authentication);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Lista de rotas que não requerem login (públicas)
    const publicRoutes = [
      '/login',
      '/esqueceu-senha',
      '/resetar-senha',
      '/resetear-senha', // Suporte para variação com 'e'
      '/terms',
      '/cadastrar-lojista',
    ];

    // Debug: log da rota atual
    console.log('🔍 UnloggedRoutes - pathname:', location.pathname);

    // Se a rota é pública, não faz verificação de login
    if (publicRoutes.some(route => location.pathname === route || location.pathname.startsWith(route))) {
      console.log('✅ Rota pública detectada, não redireciona');
      return;
    }

    if (!user.isLoggedIn()) {
      if (isEmbeddedPurchasesRoute(location.pathname, location.search)) {
        return;
      }

      const currentPath = location.pathname + location.search;

      // Rotas de área logada que devem redirecionar para login
      const loggedAreaRoutes = [
        '/',
        '/detalhes',
        '/compras',
        '/favoritos',
        '/perfis',
        '/ferramenta-comercial',
        '/atualizar-perfil',
        '/preferencias',
      ];

      const isLoggedAreaRoute = loggedAreaRoutes.some(
        route => location.pathname === route || location.pathname.startsWith(route)
      );

      if (isLoggedAreaRoute) {
        // Apenas salva o caminho para /detalhes (para voltar após login)
        // Outras rotas vão para / após login
        if (location.pathname.startsWith('/detalhes')) {
          sessionStorage.setItem('redirectAfterLogin', currentPath);
          if (location.state) {
            sessionStorage.setItem('redirectAfterLoginState', JSON.stringify(location.state));
          }
        }
        // Para outras rotas de área logada, não salva redirectAfterLogin
        // Isso faz com que após login vá para / (padrão)
        openDealerApp();
        return history.push('/login');
      }
    }
  }, [user, location]);

  return (
    <Switch>
      <Route path="/login" exact component={LoginPage} />
      <Route path="/esqueceu-senha" exact component={ForgotPasswordPage} />
      <Route path="/resetar-senha" exact component={ResetPasswordPage} />
      <Route path="/resetear-senha" exact component={ResetPasswordPage} />
      <Route path="/terms" exact component={Terms} />
      <Route path="/cadastrar-lojista" exact component={DealerRegistrationPage} />
    </Switch>
  );
};
